import React, { useContext, useMemo, useState } from 'react';
import { TFilterItem, TFilters } from '../section/Common/types/types';

type TCRMFilter = {
  createDeal?: boolean;
  priority?: string;
  tier?: number;
  assignee?: string;
};

export const baseFilter: TFilterItem = {
  amazonasin: [],
  genres: [],
  search: '',
  tag: [],
  not_tag: [],
  days_tracked: undefined,
  status_tag: undefined,
  type_tag: undefined,
  reputation: [],
  author_tags: [],
  fiction_tags: [],
  warning_tags: [],
  not_warning_tags: [],
  genre_categories: [],
  date_range: undefined,
  late_bloomer: undefined,
  start_date: '',
  end_date: '',
  min_rank: undefined,
  max_rank: undefined,
  fandom: [],
  is_complete: undefined,
  hits: undefined,
  kudos: undefined,
  published_start_date: '',
  published_end_date: '',
  last_updated_start_date: '',
  last_updated_end_date: ''
};

export const CRMFilter: TCRMFilter = {
  createDeal: undefined,
  priority: undefined,
  tier: undefined,
  assignee: undefined
};

export const defaultFilter: TFilters = {
  allnewtitles: { ...baseFilter, ...CRMFilter },
  hotTitles: { ...baseFilter, ...CRMFilter },
  topPodTitles: { ...baseFilter },
  allexcluded: { ...baseFilter },
  manuallyadded: { ...baseFilter },
  bookstatdata: { ...baseFilter },
  competitors: { ...baseFilter },
  pendingexclusion: { ...baseFilter },
  podiumsales: { ...baseFilter },
  podiumtitles: { ...baseFilter },
  sendtocrm: { ...baseFilter },
  mutedAuthors: { ...baseFilter },
  watchlist: { ...baseFilter, ...CRMFilter },
  contacted: { ...baseFilter, ...CRMFilter },
  popular: { ...baseFilter },
  trending: { ...baseFilter },
  risingStars: { ...baseFilter },
  authors: { ...baseFilter },
  podiumAuthors: { ...baseFilter },
  alltitlesRR: { ...baseFilter },
  pendingExclusionRR: { ...baseFilter },
  excludedRR: { ...baseFilter },
  watchlistRR: { ...baseFilter },
  contactedRR: { ...baseFilter },
  podiumtitlesRR: { ...baseFilter },
  senttocrmRR: { ...baseFilter },
  mutedAuthorsRR: { ...baseFilter },
  dailyRankEbooks: { ...baseFilter },
  dailyRankAudioBooks: { ...baseFilter },
  dailyRankCatalogue: { ...baseFilter },
  dailyRankPrint: { ...baseFilter },
  popularAO3: { ...baseFilter },
  watchlistAO3: { ...baseFilter },
  contactedAO3: { ...baseFilter },
  pendingExclusionAO3: { ...baseFilter },
  excludedAO3: { ...baseFilter },
  podiumtitlesAO3: { ...baseFilter },
  senttocrmAO3: { ...baseFilter },
  mutedAuthorsAO3: { ...baseFilter }
};

const FilterContext = React.createContext({
  filter: defaultFilter,
  setFilter: values => console.log(values)
});

export const FilterProvider = ({ children, filter }) => {
  const [currentFilter, setCurrentFilter] = useState(filter || defaultFilter);

  const saveFilter = values => {
    setCurrentFilter(values);
    return null;
  };

  const value = useMemo(() => ({
    filter: currentFilter,
    setFilter: saveFilter
  }), [currentFilter]);

  return (
    <FilterContext.Provider value={value}>
      {children}
    </FilterContext.Provider>
  );
};

export const FilterConsumer = FilterContext.Consumer;

export const useFilter = () => {
  const context = useContext(FilterContext);

  return context;
};

export default FilterContext;
